<template>
  <v-container class="pa-5">
    <v-tabs
      grow>
      <v-tabs-slider color="k-orange-linear" />
      <v-tab ripple>
        Arbol de gestión
      </v-tab>
      <v-tab ripple>
        Arbol de compromisos
      </v-tab>
      <v-tab-item>
        <workflow-tree
          :workflow="workflow"
          :stages="stages"
          :stages-key="stagesKey"
          :is-whatsapp-outbound-active="isWhatsappOutboundActive"
          @stage-created="stageCreated"
          @stage-updated="stageUpdated"
          @stage-deleted="stageDeleted"
          @filter-created="filterCreated"
          @filter-updated="filterUpdated"
          @filter-deleted="filterDeleted"/>
      </v-tab-item>
      <v-tab-item>
        <payment-promise-tree
          :key="pStagesKey"
          :workflow="workflow"
          :p-stages="pStages"
          :is-whatsapp-outbound-active="isWhatsappOutboundActive"
          @p-stage-created="pStageCreated"
          @p-stage-updated="pStageUpdated"
          @p-stage-deleted="pStageDeleted"
          @p-filter-created="pFilterCreated"
          @p-filter-updated="pFilterUpdated"
          @p-filter-deleted="pFilterDeleted"/>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import WorkflowTree from '@/components/V2CollectWorkflows/Detail/WorkflowTree/Index';
import PaymentPromiseTree from '@/components/V2CollectWorkflows/Detail/PaymentPromiseTree/Index';
import filtersMixin from '@/mixins/workflowFilters';

const uuidv1 = require('uuid/v1');

export default {
  components: {
    WorkflowTree,
    PaymentPromiseTree,
  },
  beforeRouteEnter(to, from, next) {
    const workflowId = to.params.workflow;
    Promise.all([
      Vue.axios.get(`workflows/${workflowId}`),
      Vue.axios.get(`v3/workflows/${workflowId}/stages`),
      Vue.axios.get(`workflows/${workflowId}/payment_p_stages`),
      filtersMixin.methods.findFilters(),
      Vue.axios.get('check_release', { params: { name: 'colly_senders_api_sms' } }),
      Vue.axios.get('check_release', { params: { name: 'colly_senders_api_email' } }),
      Vue.axios.get('check_release', { params: { name: 'colly_senders_api_whatsapp' } }),
      // Vue.axios.get('check_release', { params: { name: 'whatsapp_outbound_project' } }),
    ]).then((values) => {
      next((vm) => {
        vm.workflow = values[0].data; // eslint-disable-line
        vm.stages = values[1].data; // eslint-disable-line
        vm.pStages = values[2].data; // eslint-disable-line
        vm.collyRelease.sms = values[4].data.is_active === true; // eslint-disable-line
        vm.collyRelease.email = values[5].data.is_active === true; // eslint-disable-line
        vm.collyRelease.whatsapp = values[6].data.is_active === true; // eslint-disable-line
        // vm.isWhatsappOutboundActive = values[4].data.is_active;
        vm.sortStages();
      });
    }).catch(() => {});
  },
  mixins: [
    filtersMixin,
  ],
  // Release de colly por canal, una vez por página: los diálogos de plantillas lo inyectan.
  provide() {
    return { collyRelease: this.collyRelease };
  },
  data() {
    return {
      workflow: {},
      stages: [],
      pStages: [],
      pStagesKey: uuidv1(),
      stagesKey: uuidv1(),
      collyRelease: { sms: false, email: false, whatsapp: false },
      isWhatsappOutboundActive: true,
    };
  },
  methods: {
    sortStages() {
      // eslint-disable-next-line
      this.stages = _.sortBy(this.stages, item => parseInt(item.order, 10) - parseInt(item.global || 0, 10));
      this.stagesKey = uuidv1();
    },
    stageCreated(stage) {
      let stages = this.stages.filter(item => item.global === stage.global);
      if (stage.global) {
        this.stages.splice(stage.order - 1, 0, stage);
      } else {
        const globalStages = this.stages.filter(item => item.global === 1);
        let position = stage.order - 1;
        if (globalStages.length) {
          position = Math.abs(position - globalStages.length - 1);
        }
        this.stages.splice(position, 0, stage);
      }
      stages = this.stages.filter(item => item.global === stage.global);
      for (let i = 1; i <= stages.length; i += 1) {
        const index = this.stages.findIndex(item => item.id === stages[i - 1].id);
        this.stages[index].order = i;
      }
      this.sortStages();
    },
    stageUpdated(selectedStage) {
      const index = this.stages.findIndex(item => item.id === selectedStage.id);
      const currentOrder = this.stages[index].order;
      const newOrder = selectedStage.order;
      if (newOrder < currentOrder) {
        const stageCopy = _.cloneDeep(this.stages);
        for (let i = newOrder; i < currentOrder; i += 1) {
          const index2 = stageCopy.findIndex(item => (
            item.order === i
            && item.global === selectedStage.global
          ));
          this.stages[index2].order = i + 1;
        }
      } else if (newOrder > currentOrder) {
        for (let i = currentOrder + 1; i <= newOrder; i += 1) {
          const index2 = this.stages.findIndex(item => (
            item.order === i
            && item.global === selectedStage.global
          ));
          this.stages[index2].order = i - 1;
        }
      }
      const stage = {
        ...this.stages[index],
        ...selectedStage,
      };
      if (this.stages[index].status === 'Activo' && stage.status === 'Inactivo') {
        for (let i = 0; i < stage.filters.length; i += 1) {
          stage.filters[i].status = 'Inactivo';
        }
      }
      this.$set(this.stages, index, stage);
      this.sortStages();
    },
    stageDeleted(selectedStage) {
      const index = this.stages.findIndex(item => item.id === selectedStage.id);
      this.stages.splice(index, 1);
      this.sortStages();
    },
    filterCreated(selectedStage, filter) {
      const stage = {
        ...selectedStage,
      };
      if (filter.order === stage.filters.length) {
        stage.filters.push(filter);
      } else {
        stage.filters.splice(filter.order - 1, 0, filter);
      }
      for (let i = 1; i <= stage.filters.length; i += 1) {
        stage.filters[i - 1].order = i;
      }
      stage.filters = _.sortBy(stage.filters, item => item.order);
      const index = this.stages.findIndex(item => item.id === stage.id);
      this.$set(this.stages, index, stage);
    },
    filterUpdated(selectedStage, filter) {
      const stage = {
        ...selectedStage,
      };
      const index = stage.filters.findIndex(item => item.id === filter.id);
      const currentOrder = stage.filters[index].order;
      const newOrder = filter.order;
      if (newOrder < currentOrder) {
        for (let i = newOrder; i < currentOrder; i += 1) {
          const index2 = stage.filters.findIndex(item => item.order === i);
          stage.filters[index2].order = i + 1;
        }
      } else if (newOrder > currentOrder) {
        for (let i = currentOrder + 1; i <= newOrder; i += 1) {
          const index2 = stage.filters.findIndex(item => item.order === i);
          stage.filters[index2].order = i - 1;
        }
      }
      stage.filters[index] = filter;
      stage.filters = _.sortBy(stage.filters, item => item.order);
      this.stageUpdated(stage);
    },
    filterDeleted(selectedStage, selectedFilter) {
      const stage = {
        ...selectedStage,
      };
      const index = stage.filters.findIndex(item => item.id === selectedFilter.id);
      stage.filters.splice(index, 1);
      for (let i = 1; i <= stage.filters.length; i += 1) {
        stage.filters[i - 1].order = i;
      }
      stage.filters = _.sortBy(stage.filters, item => item.order);
      this.stageUpdated(stage);
    },
    sortPStages() {
      this.pStages = _.sortBy(this.pStages, item => parseInt(item.days_off, 10));
      this.pStagesKey = uuidv1();
    },
    pStageCreated(pStage) {
      this.pStages.push(pStage);
      this.sortPStages();
    },
    pStageUpdated(selectedPStage) {
      const index = this.pStages.findIndex(item => item.id === selectedPStage.id);
      const pStage = {
        ...this.pStages[index],
        ...selectedPStage,
      };
      if (this.pStages[index].status === 1 && pStage.status === 0) {
        for (let i = 0; i < pStage.filters.length; i += 1) {
          pStage.filters[i].status = 0;
        }
      }
      this.$set(this.pStages, index, pStage);
      this.sortPStages();
    },
    pStageDeleted(selectedPStage) {
      const index = this.pStages.findIndex(item => item.id === selectedPStage.id);
      this.pStages.splice(index, 1);
      this.sortPStages();
    },
    pFilterCreated(selectedPStage, pFilter) {
      const stage = {
        ...selectedPStage,
      };
      stage.filters.push(pFilter);
      const index = this.stages.findIndex(item => item.id === stage.id);
      this.$set(this.stages, index, stage);
    },
    pFilterUpdated(selectedPStage, pFilter) {
      const pStage = {
        ...selectedPStage,
      };
      const index = pStage.filters.findIndex(item => item.id === pFilter.id);
      pStage.filters[index] = pFilter;
      this.pStageUpdated(pStage);
    },
    pFilterDeleted(selectedPStage, pFilter) {
      const pStage = {
        ...selectedPStage,
      };
      const index = pStage.filters.findIndex(item => item.id === pFilter.id);
      pStage.filters.splice(index, 1);
      this.stageUpdated(pStage);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/Index.vue